import {
  ACKNOWLEDGE_UPLOADED_DOCUMENT,
  ACKNOWLEDGE_UPLOADED_DOCUMENT_EMPTY,
  ACKNOWLEDGE_UPLOADED_DOCUMENT_ERROR,
  ACKNOWLEDGE_UPLOADED_DOCUMENT_SUCCESS,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AcknowledgeUploadedDocument = (state = initialState, action) => {
  switch (action.type) {
    case ACKNOWLEDGE_UPLOADED_DOCUMENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ACKNOWLEDGE_UPLOADED_DOCUMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ACKNOWLEDGE_UPLOADED_DOCUMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ACKNOWLEDGE_UPLOADED_DOCUMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AcknowledgeUploadedDocument;
